import React, { useState, useEffect } from "react";
import { resetPassword } from "./authenticationAPI";
import { Button, Modal } from "react-bootstrap";

const Profile: React.FC = () => {
    const [userEmail, setUserEmail] = useState<string>("");
    const [userName, setUserName] = useState<string>("");
    const [userRole, setUserRole] = useState<string>("");
    const [userId, setUserId] = useState<string>("");
    const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
    const [currentPassword, setCurrentPassword] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [modalMessage, setModalMessage] = useState<string>("");
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        setUserEmail(localStorage.getItem("userEmail") || "");
        setUserName(localStorage.getItem("userName") || "");
        setUserRole(localStorage.getItem("userRole") || "");
        setUserId(localStorage.getItem("userUuid") || "");
    }, []);

    const handlePasswordReset = async () => {
        if (newPassword !== confirmPassword) {
            setModalMessage("Passwords do not match");
            setShowModal(true);
            return;
        }
        try {
            const response = await resetPassword(userId, currentPassword, newPassword, confirmPassword);
            if (response.data.code === 200) {
                setModalMessage("Password changed successfully");
                setShowModal(true);
                setShowChangePassword(false);
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
            }
        } catch (error) {
            setModalMessage("Failed to change password. Please try again.");
            setShowModal(true);
        }
    };


    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-4">
                                    <h4 className="page-title">Profile</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">User Information</h5>
                                <p><strong>Email:</strong> {userEmail}</p>
                                <p><strong>Name:</strong> {userName}</p>
                                <p><strong>Role:</strong> {userRole}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-end">
                        {!showChangePassword ? (
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => setShowChangePassword(true)}
                            >
                                Change Password
                            </button>
                        ) : (
                            <div className="card h-100">
                                <div className="card-body">
                                    <h5 className="card-title text-start">Change Password</h5>
                                    <input
                                        type="password"
                                        className="form-control mb-2"
                                        placeholder="Current Password"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                    />
                                    <input
                                        type="password"
                                        className="form-control mb-2"
                                        placeholder="New Password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <input
                                        type="password"
                                        className="form-control mb-2"
                                        placeholder="Confirm Password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                    <div className="text-end">
                                        <button className="btn btn-success btn-sm me-2" onClick={handlePasswordReset}>OK</button>
                                        <button className="btn btn-secondary btn-sm" onClick={() => setShowChangePassword(false)}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Notification</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowModal(false)}>OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Profile;